import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, ArrowLeft } from 'lucide-react';
import { LOGO, PHONE_NUMBER, PHONE_TEL_HREF } from '../../constants/site';

// Shared chrome for the native blog pages (index + post).
export const BlogLayout = ({ children, backTo, backLabel }) => (
  <div className="min-h-screen bg-ivory text-neutral-800" data-testid="blog-layout">
    <header className="bg-[#143160] text-white">
      <div className="max-w-5xl mx-auto px-5 py-4 flex items-center justify-between">
        <Link to="/" data-testid="blog-home-link"><img src={LOGO} alt="Jess Sells East Coast" className="h-12 w-auto brightness-0 invert" /></Link>
        <a href={PHONE_TEL_HREF} data-testid="blog-call-link" className="flex items-center space-x-2 font-bold text-gold-300 hover:text-gold-200"><Phone className="w-4 h-4" /><span>{PHONE_NUMBER}</span></a>
      </div>
    </header>
    <div className="max-w-5xl mx-auto px-5 pt-6">
      <Link to={backTo} data-testid="blog-back-link" className="inline-flex items-center text-sm font-semibold text-[#143160] hover:text-gold-600"><ArrowLeft className="w-4 h-4 mr-1" />{backLabel}</Link>
    </div>
    {children}
    <footer className="bg-[#143160] text-white py-10 text-center px-5 mt-16">
      <p className="font-serif text-2xl sm:text-3xl">Don't stress, <span className="gold-gradient-text font-black">CALL JESS</span> &amp; FORGET THE REST!</p>
      <p className="text-sm text-white/70 mt-3">Jess Sells East Coast · Jessica Burnette, REALTOR® · Swell Realty Co. · 2122 General Booth Blvd Suite 104, Virginia Beach, VA 23454</p>
      <a href={PHONE_TEL_HREF} className="inline-block mt-4 text-gold-300 font-bold">{PHONE_NUMBER}</a>
    </footer>
  </div>
);

export const PostCard = ({ post, large = false, headingLevel = 'h3' }) => {
  const Heading = headingLevel;
  return (
  <Link to={`/blog/${post.slug}`} data-testid={`post-card-${post.slug}`} className="group block bg-sand-50 rounded-2xl overflow-hidden border border-[#143160]/10 shadow-sm hover:shadow-xl transition-shadow">
    <div className={`${large ? 'aspect-[16/9]' : 'aspect-[4/3]'} overflow-hidden bg-[#143160]`}>
      <img src={post.cover} alt={post.coverAlt} loading="lazy" className="w-full h-full object-cover object-top group-hover:scale-[1.03] transition-transform duration-500" />
    </div>
    <div className="p-6 space-y-2">
      <p className="text-xs font-bold tracking-[0.2em] uppercase text-gold-600">{post.category} · {post.readTime}</p>
      <Heading className={`font-serif text-[#143160] leading-tight ${large ? 'text-3xl' : 'text-2xl'}`}>{post.title}</Heading>
      <p className="text-neutral-600 text-sm leading-relaxed">{post.excerpt}</p>
    </div>
  </Link>
  );
};
